module.exports = __webpack_public_path__ + "img/ACA4.43f31843.jpeg";